@if (hasOutstandingAction()) {
  <div class="flex flex-col gap-4 mb-4">
    <div class="w-full h-[1px] bg-surface-200"></div>

    @if (prepaymentOutstanding()) {
      @if (canProcessPrepayment()) {
        <div class="self-stretch justify-start text-text-color text-sm font-normal font-['Inter'] leading-5">
          This TA requires prepayment processing.
        </div>
        <p-button [severity]="'primary'" data-testId="process-prepayment-btn" styleClass="w-64 hover:cursor" (onClick)="confirmProcessPrepayment()">
          <i class="fa-regular fa-layer-group pl-[1px]"></i>
          <span class="flex-1">Prepayment Processed</span>
        </p-button>
      } @else {
        <div class="self-stretch justify-start text-text-color text-sm font-normal font-['Inter'] leading-5">
          Awaiting prepayment processing by Finance Unit.
        </div>
      }
    }

    @if (overpaymentOutstanding()) {
      @if (canProcessDeduction()) {
        <div class="self-stretch justify-start text-text-color text-sm font-normal font-['Inter'] leading-5">
          This TA requires an overpayment deduction.
        </div>
        <p-button [severity]="'primary'" data-testId="process-deduction-btn" styleClass="w-64" (onClick)="confirmProcessDeduction()">
          <i class="fa-regular fa-layer-group pl-[1px]"></i>
          <span class="flex-1">Process Overpayment Deduction</span>
        </p-button>
      } @else {
        <div class="self-stretch justify-start text-text-color text-sm font-normal font-['Inter'] leading-5">
          Awaiting overpayment processing by Compliance.
        </div>
      }
    }

    @if (dayTripPaymentOutstanding()) {
      @if (canProcessDayTripPayment()) {
        <div class="self-stretch justify-start text-text-color text-sm font-normal font-['Inter'] leading-5">
          This TA requires a day trip payment.
        </div>
        <p-button [severity]="'primary'" data-testId="process-day-trip-payment-btn" styleClass="w-64" (onClick)="confirmProcessDayTripPayment()">
          <i class="fa-regular fa-layer-group pl-[1px]"></i>
          <span class="flex-1">Day Trip Payment Processed</span>
        </p-button>
      } @else {
        <div class="self-stretch justify-start text-text-color text-sm font-normal font-['Inter'] leading-5">
          Awaiting day trip payment processing by Compliance.
        </div>
      }
    }
  </div>
}

@if (canCancelPrepayment()) {
  <div class="flex flex-col gap-4 mb-4">
    @if (!hasOutstandingAction()) {
      <div class="w-full h-[1px] bg-surface-200"></div>
    }
    <p-button [severity]="'danger'" data-testId="cancel-prepayment-btn" styleClass="w-64 hover:cursor" (onClick)="confirmCancelPrepayment(isPrepaymentProcessed())">
      <i class="fa-regular fa-ban pl-[1px]"></i>
      <span class="flex-1">Cancel Prepayment</span>
    </p-button>
  </div>
}
